<template>
  <v-container>
    <v-card width="400" class="mx-auto" v-if="flag">
      <v-toolbar elevation="0">
        <v-card-title class="mx-auto headline font-weight-bold">
          Autenticación exitosa
        </v-card-title>
      </v-toolbar>
      <v-card-text class="pt-0">
        <v-img :src="require('@/assets/icon_check.png')"></v-img>
        <div class="font-weight-bold title text-center black--text">
          Ahora puede cerrar esta ventana
        </div>
      </v-card-text>
    </v-card>
    <v-card width="400" class="mx-auto" v-else>
      <v-toolbar elevation="0">
        <v-card-title class="mx-auto headline font-weight-bold">
          No se pudo autenticar
        </v-card-title>
      </v-toolbar>
      <v-card-text class="pt-0">
        <v-img :src="require('@/assets/icon_no_check.png')"></v-img>
        <div class="font-weight-bold title text-center black--text">
          Cierre esta ventana y vuelva a intentar
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      flag: true,
    };
  },
  created() {
    this.hrefUrl();
  },
  methods: {
    hrefUrl() {
      let url = window.location.href;
      this.obtenerToken(url.split(/[=&]+/)[1]);
    },
    obtenerToken(codigo) {
      axios
        .post("api/Usuarios/ObtenerToken", {
          codigo: codigo,
          redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        })
        .then((response) => {
          //this.verificarAccesosExistentes(response.data);
          this.guardarRefreshToken(response.data.refresh_token);
        })
        .catch((error) => {
          this.flag = false;
        });
    },
    ///////////////////CREAR LAS CREDENCIALES///////////////////////////////////
    async verificarAccesosExistentes(obj) {
      let credenciales = await this.listarCredencialesOneDrive(this.$store.state.usuario.idUsuario);

      if(credenciales.length > 0) {
        this.actualizarAccesos(obj);
      } else {
        this.guardarAccesos(obj);
      }
    },
    guardarAccesos(obj) {
      Promise.all([
        this.guardarAccessToken(obj.access_token),
        this.guardarRefreshToken(obj.refresh_token),
        this.guardarExpiresIn(),
      ])
        .then((response) => {
          localStorage.setItem("credentials", "si");
        })
        .catch(() => {
          this.flag = false;
        });
    },
    actualizarAccesos(obj) {
      Promise.all([
        this.actualizarAccessToken(obj),
        this.actualizarRefreshToken(obj),
        this.actualizarRefreshToken(),
      ])
        .then((response) => {
          localStorage.setItem("credentials", "si");
        })
        .catch(() => {
          this.flag = false;
        });
    },
    guardarAccessToken(valor) {
      return axios.post("api/DriveLlaves/Crear", {
        idUsuario: parseInt(this.$store.state.usuario.idUsuario),
        clave: "access_token",
        valor: this.encriptarDato(valor),
      });
    },
    guardarRefreshToken(valor) {
      return axios.post("api/DriveLlaves/Crear", {
        idUsuario: parseInt(this.$store.state.usuario.idUsuario),
        clave: "refresh_token",
        valor: valor,
      });
    },
    guardarExpiresIn() {
      return axios.post("api/DriveLlaves/Crear", {
        idUsuario: this.$store.state.usuario.idUsuario,
        clave: "expires_in",
        valor: new Date().getTime() + 1 * 60 * 60 * 1000,
      });
    },
    ///////////////////ACTUALIZAR LAS CREDENCIALES///////////////////////////////////
    actualizarAccessToken(obj) {
      return axios.put("api/DriveLlaves/Actualizar", {
        id_drive_llaves: obj.id_drive_llaves,
        idUsuario: this.$store.state.usuario.idUsuario,
        clave: "access_token",
        valor: this.encriptarDato(obj.valor),
      });
    },
    actualizarRefreshToken(obj) {
      return axios.put("api/DriveLlaves/Actualizar", {
        id_drive_llaves: obj.id_drive_llaves,
        idUsuario: this.$store.state.usuario.idUsuario,
        clave: "refresh_token",
        valor: this.encriptarDato(obj.valor),
      });
    },
    actualizarExpiresIn(obj) {
      return axios.put("api/DriveLlaves/Actualizar", {
        id_drive_llaves: obj.id_drive_llaves,
        idUsuario: this.$store.state.usuario.idUsuario,
        clave: "expires_in",
        valor: new Date().getTime() + 1 * 60 * 60 * 1000,
      });
    },
    async listarCredencialesOneDrive(id_usuario) {
        const credenciales = await axios.get(
            "api/DriveLlaves/Listar/" + id_usuario
        );
        return credenciales.data;
    },
    ///////////////////ENCRIPTACION DE DATOS///////////////////////////////////
    encriptarDato(valor) {
      var CryptoJS = require("crypto-js");
      var ciphertext = CryptoJS.AES.encrypt(valor, "R3gi0n@l_2@22").toString();
      return ciphertext;
    },
    desencriptarDato(valor) {
      var CryptoJS = require("crypto-js");
      var bytes = CryptoJS.AES.decrypt(valor, "R3gi0n@l_2@22");
      return bytes.toString(CryptoJS.enc.Utf8);
    },
  },
};
</script>